import request from '@/api/config/request'

export function getDiario(dia_numero, options = {}) {
  return request({
    url: `/diario/${dia_numero}`,
    method: 'get',
    params: options
  })
}

export function putDownload(data) {
  return request({
    url: `/diario/${data.dia_codigo}`,
    method: 'put'
  })
}

